import React, { useEffect, useState } from 'react';

const dateTime = (value) => value
  ? `${new Date(value).toLocaleString('en-GB', { timeZone: 'UTC', hour12: false })} UTC`
  : '—';

const CampaignAudienceSnapshot = ({ campaign }) => {
  const [current, setCurrent] = useState(campaign);
  const snapshot = current.audience_snapshot;
  const waiting = !snapshot && ['pending', 'scheduled'].includes(current.status);

  useEffect(() => {
    if (!waiting) return;
    let active = true;
    let timer;
    const refresh = async () => {
      try {
        const response = await fetch(`/campaigns/${campaign.id}.json`);
        if (response.ok) {
          const data = await response.json();
          if (active) setCurrent(data);
        }
      } catch (_) {
        // Следующий запрос восстановит состояние после временного сбоя.
      } finally {
        if (active) timer = setTimeout(refresh, 15000);
      }
    };
    timer = setTimeout(refresh, 15000);
    return () => { active = false; clearTimeout(timer); };
  }, [campaign.id, waiting]);

  return <section className='campaign-audience-snapshot' aria-label='Audience snapshot'>
    <h3>Audience snapshot</h3>
    {snapshot ? <>
      {snapshot.refreshed_at && <p><strong>Segment refreshed before launch</strong></p>}
      <dl>
        {(snapshot.segments?.length || snapshot.segment_name) && <div><dt>Segments</dt>
          <dd>{snapshot.segments?.map((segment) => segment.segment_name).join(', ') || snapshot.segment_name}</dd></div>}
        {snapshot.refreshed_at && <div><dt>Successful refresh</dt><dd>{dateTime(snapshot.refreshed_at)}</dd></div>}
        <div><dt>Snapshot saved</dt><dd>{dateTime(current.audience_snapshotted_at)}</dd></div>
        <div><dt>Recipients fixed for this campaign</dt><dd>{Number(snapshot.recipients_count).toLocaleString('en-US')}</dd></div>
      </dl>
      <p>Later segment updates do not change these recipients or this record.</p>
    </> : <p>{waiting
      ? current.dynamic_segment ? 'Awaiting launch: the segment will be refreshed before recipients are fixed.' : 'Audience snapshot is being prepared.'
      : 'No audience snapshot record was saved for this campaign. A pre-send refresh cannot be confirmed here.'}</p>}
  </section>;
};

export default CampaignAudienceSnapshot;
